var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 87.4h8.6l-1 6.6H57l-1-6.6ZM84.5 68.4v-8.6l6.7 1v6.6l-6.7 1ZM37 68.4v-8.6l-6.6 1v6.6l6.6 1ZM45.1 45.1l7.4-4.2-4.1-5.3-5.8 3.3 2.5 6.2ZM75.8 81.4l-7.4 4.3 4.1 5.3 5.8-3.4-2.5-6.2ZM45.1 81.4l7.4 4.3-4.1 5.3-5.8-3.4 2.5-6.2ZM83.1 71.2l-4.3 7.4 6.3 2.5 3.3-5.7-5.3-4.2Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 44.1 51 56.2 40.4 67.6 31 79.1 16 64l10.5-8.5L38.8 44Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1 9.4a15 15 0 0 0-19.2.9l-5.6 5.1-5.1 5.6a15 15 0 0 0 0 20.3l7.1 7.7 7.7 7a15 15 0 0 0 20.3.1l5.6-5 5.1-5.7a15 15 0 0 0 .9-19.2L67.4 44.7a2 2 0 0 1-2.8 0l-14-14a2 2 0 0 1 0-2.8L69.1 9.4ZM20.3 91.4c18-18 24.8-32.3 20.1-37-4.6-4.6-18.9 2.1-37 20.2a11.9 11.9 0 1 0 16.9 16.8ZM7.7 87a5.7 5.7 0 0 0 8 0C18 85 21.3 78 19.1 75.7c-2.2-2.2-9.2 1.1-11.4 3.4a5.7 5.7 0 0 0 0 8ZM81.6 52.7l2-1.9 2.8-3 2 3.4-5.3 4.1-1.5-2.6Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m61.3 39.9-4.6-4.7.3-2h6.6l1 6.7h-3.3Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2 73.7a24.7 24.7 0 1 0 44.3-21.9l-5.9 5.4a17 17 0 0 1-15.8 23.5c-8.3 0-15.2-6-16.8-13.8l-1.5 1.7-4.3 5.1Zm27.9-32 1.8-1.8a24.7 24.7 0 0 0-7.5-1l2.8 2.9c.8.7 2 .7 2.9 0Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 78.3 36 81l6.2-2.5-3.3-5.8-4.5 5.5ZM52 58.2l-4.5 5v.4a13.3 13.3 0 1 0 26-3.6 15 15 0 0 1-7 3.3 5.7 5.7 0 0 1-5.7 6 5.7 5.7 0 0 1-5.2-8.1 15 15 0 0 1-2-1.6L52 58.2Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance-icon.f0d49c23f3d46f854f64e74e86076f29.svg";
export { ForwardRef as ReactComponent };